async function request(path: string, init: RequestInit = {}) {
  const token = localStorage.getItem('resume_access_token')
  if (!token) throw new Error('Please sign out and sign in again to access resumes')
  const response = await fetch(path, { ...init, cache: 'no-store', headers: {
    ...init.headers, Authorization: `Bearer ${token}`,
  } })
  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw new Error(typeof body.detail === 'string' ? body.detail : 'Resume request failed. Please retry.')
  }
  return response
}

export async function uploadResume(file: File, registrationLink: string) {
  const response = await request('/api/v1/resume-storage/upload', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ registration_link: registrationLink, file_name: file.name, file_size: file.size, file_type: 'application/pdf' }),
  })
  const grant = await response.json()
  // The browser derives Content-Length from this File; the signature binds
  // that exact length, content type, object key and private ACL.
  const uploaded = await fetch(grant.upload.url, { method: 'PUT', headers: grant.upload.headers,
    body: file, credentials: 'omit', referrerPolicy: 'no-referrer' })
  if (!uploaded.ok) throw new Error('Resume upload failed. Please retry.')
  return { upload_token: grant.upload_token }
}

export async function registerWithResume(data: unknown) {
  return (await request('/api/v1/drives/register', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })).json()
}

export async function downloadResume(registrationId: number, fileName: string) {
  const response = await request(`/api/v1/resume-storage/registrations/${registrationId}/download`)
  const link = document.createElement('a')
  let blobUrl: string | undefined
  if (response.headers.get('Content-Type')?.includes('application/json')) {
    link.href = (await response.json()).url
    link.rel = 'noreferrer'
    link.referrerPolicy = 'no-referrer'
  } else {
    blobUrl = URL.createObjectURL(await response.blob())
    link.href = blobUrl
    link.download = fileName
  }
  document.body.appendChild(link)
  link.click()
  link.remove()
  if (blobUrl) setTimeout(() => URL.revokeObjectURL(blobUrl!), 1000)
}
